import React, { useEffect, useState } from 'react';
import "./RecordFormServices.scss"

import Dropdown from '../../../UI/Dropdown/Dropdown'

import { useSelector, useDispatch } from 'react-redux';
import { useFetching } from '../../../../hooks/useFetching';
import PostService from '../../../../API/PostService';
import { setServicesAction } from '../../../../store/servicesReducer';

const RecordFormServices = ({selectHandler = null, selectedService = null}) => {
	const dispatch = useDispatch();
	const services = useSelector(state => state.services.services)
	const [ defaultService, setDefaultService ] = useState(null);

	useEffect(() => {
		if(!services || services.length === 0){
			fetchServices();
		}
	}, [])

	useEffect(() => {
		if(selectedService && services){
			const service = services.find((el) => Number(el.id) === Number(selectedService))
			if(service) setDefaultService(service)
		}
	}, [selectedService, services])

	const [fetchServices] = useFetching(async () => {
		const response = await PostService.getServices()
		if (response.data.success && response.data.result !== false) {
			dispatch(setServicesAction(response.data.result))
		}
	})

	return (
		<div className="record-form-services">
			{
				(selectedService && defaultService || !selectedService) &&
				<Dropdown
					optionsList={services}
					optionSelected={defaultService}
					type='services'
					label='Услуга'
					selectedHandler={selectHandler}/>
			}
		</div>
	);
};

export default RecordFormServices;
